import { render } from "./TagOutline.vue?vue&type=template&id=24a99540"
import script from "./TagOutline.vue?vue&type=script&lang=js"
export * from "./TagOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__